<svg-icon
  src="{{ name }}.svg"
  [svgStyle]="{
    'width.px': width,
    'height.px': height,
  }"
></svg-icon>
